/**
 * Tracks MIME types of blob URLs so components like MediaDisplay
 * can determine whether a blob URL is a video or image.
 *
 * Blob URLs (e.g. blob:http://localhost:5173/uuid) have no file extension,
 * so we store the original file's MIME type when creating the blob URL.
 */

const blobMediaTypes = new Map<string, string>();

/** Create a blob URL and store the file's MIME type for later lookup. */
export function createMediaBlobUrl(file: File): string {
  const url = URL.createObjectURL(file);
  blobMediaTypes.set(url, file.type);
  return url;
}

/** Check if a blob URL points to a video file. */
export function isBlobVideoUrl(url: string): boolean {
  const type = blobMediaTypes.get(url);
  return type?.startsWith('video/') ?? false;
}

/** Revoke a blob URL and clean up the stored type. */
export function revokeMediaBlobUrl(url: string): void {
  URL.revokeObjectURL(url);
  blobMediaTypes.delete(url);
}
